"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultMissingAndDisabledProductOptions = void 0;
const productHelpers_1 = require("../../../utils/productHelpers");
const defaultMissingAndDisabledProductOptions = _ref => {
  let {
    options: _options,
    artAttributes,
    artAttributeRestrictions
  } = _ref;
  const options = Object.assign({}, _options);
  // Get the list of product options that takes into account attribute restrictions
  const cleanedProductOptions = (0, productHelpers_1.disableAttributesIfRestricted)(artAttributes, artAttributeRestrictions, options);
  // If the new list of product options has any options that aren't included in the cleaned list, remove them
  // Otherwise, ensure options are in a valid state given restrictions/disabled states
  Object.keys(options).forEach(key => {
    var _a;
    if (!cleanedProductOptions[key]) {
      delete options[key];
    } else if ((_a = cleanedProductOptions[key].options.find(o => o.value === options[key])) === null || _a === void 0 ? void 0 : _a.disabled) {
      // if the current option selected is disabled, pick a new valid option
      const validOptions = cleanedProductOptions[key].options.filter(o => !o.disabled);
      if (validOptions.length) {
        options[key] = validOptions[0].value;
      } else {
        delete options[key];
      }
    }
  });
  // If there are any options in the cleaned list that aren't currently in the project options, add them
  Object.keys(cleanedProductOptions).forEach(key => {
    const validOptions = cleanedProductOptions[key].options.filter(o => !o.disabled);
    if (!options[key] && validOptions.length) {
      options[key] = validOptions[0].value;
    }
  });
  return options;
};
exports.defaultMissingAndDisabledProductOptions = defaultMissingAndDisabledProductOptions;